import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

interface DropzoneUploaderProps {
  onFilesSelected: (files: File[]) => void;
}

const DropzoneUploader: React.FC<DropzoneUploaderProps> = ({ onFilesSelected }) => {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    onFilesSelected(acceptedFiles);
  }, [onFilesSelected]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    accept: {
      'application/zip': ['.zip'],
      'application/x-rar-compressed': ['.rar'],
      'application/x-7z-compressed': ['.7z'],
      'model/stl': ['.stl'],
      'application/dicom': ['.dcm'],
      'text/xml': ['.xml'],
      'application/octet-stream': ['.constructionInfo'],
    },
  });

  return (
    <div
      {...getRootProps()}
      className="border-2 border-dashed p-6 text-center rounded cursor-pointer hover:border-green-500 transition"
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>Lasă fișierele aici...</p>
      ) : (
        <p>Drag files here or click to select them</p>
      )}
    </div>
  );
};

export default DropzoneUploader;
